import { useQuery } from '@tanstack/react-query';
import { proposalConfigurationApi } from '@/api/commercial/proposal-configurations';

export function useConfigurationProfiles(proposalId?: string, groupId?: string) {
  return useQuery({
    queryKey: ['configuration-profiles', proposalId, groupId],
    queryFn: () => proposalConfigurationApi.getAvailableProfiles(proposalId!, groupId!),
    enabled: !!proposalId && !!groupId,
  });
}
